// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7ecb6c24","845":"767da433"}[chunkId] + ".chunk.js";
};